import { Box, Typography } from '@mui/material';
import React from 'react';
import { PageTitleProps } from '../../lib/types/types';

export const PageTitle: React.FC<PageTitleProps> = ({ title, subtitle }) => (
  <Box sx={{ mb: 2 }}>
    <Typography variant="h4" component="h1" sx={{ fontWeight: 700 }}>
      {title}
    </Typography>
    {subtitle && (
      <Typography variant="body1" color="primary.main">
        {subtitle}
      </Typography>
    )}
  </Box>
);